<template>
  <div>
    <div >
      <v-pagination
        :value="page"
        :length="length"
        :total-visible="7"
        @input="changePage"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
    export default {
      props: {
        length: {
          type : Number,
          default : 1
        },
        page: {
          type : Number,
          default : 1
        },
      },
        name: "Paginate",
      data () {
        return {

        }
      },
      methods:{
        changePage(val){
          this.$emit("update",val)
        }
      }
    }
</script>

<style>
  .theme--light.v-pagination .v-pagination__item--active {
    color: #ffffff !important;
    background-color: #2E8037 !important;
  }
</style>
